import { useState, useCallback } from 'react';

const useAgreementText = () => {
  const [ agreementUserText, setAgreementUserText ] = useState('');
  const [ agreementPrivacyText, setAgreementPrivacyText ] = useState('');
  
  return {
    agreementUserText,
    setAgreementUserText,
    agreementPrivacyText,
    setAgreementPrivacyText
  };
};

export {
  useAgreementText
};